import React from 'react';
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import { createRoot } from 'react-dom/client';

import ObjectSliderModal from '@/components/Modals/ObjectSliderModal';
import renderCustomBullets from '@/pages/shared/bullets';
import { SlideItem } from '@/types/common';

interface SliderMainOptions {
  elementId: string;
  slides: number;
}

interface SliderModalOptions {
  elementId: string;
  buttonId: string;
  planButtonId?: string;
  planIndex?: number | null;
  slides: SlideItem[];
  title: string;
  gallery: string;
}

const initSlider = (main: SliderMainOptions, modal: SliderModalOptions): void => {
  const container = document.querySelector(modal.elementId);

  if (!container) {
    return;
  }

  let openModal: ((index?: number) => void) | null = null;

  const root = createRoot(container);

  root.render(
    <ObjectSliderModal
      buttonId={modal.buttonId}
      slides={modal.slides}
      title={modal.title}
      gallery={modal.gallery}
      onInit={(open) => {
        openModal = open;
      }}
    />
  );

  new Swiper(`${main.elementId} .swiper`, {
    modules: [Navigation, Pagination, Keyboard],
    on: {
      click: (swiper) => {
        openModal?.(swiper.realIndex);
      }
    },
    pagination: {
      el: `${main.elementId} .swiper-pagination`,
      type: 'custom',
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      renderCustom: renderCustomBullets
    },
    navigation: {
      nextEl: `${main.elementId} .swiper-button-next`,
      prevEl: `${main.elementId} .swiper-button-prev`
    },
    slidesPerView: 1,
    keyboard: true,
    loop: true,
    speed: 400,
    breakpoints: {
      1024: {
        speed: 800
      }
    }
  });

  if (modal.planButtonId && modal.planIndex != null) {
    const planButton = document.querySelector(modal.planButtonId);
    const planIndex = modal.planIndex;

    planButton?.addEventListener('click', () => {
      openModal?.(planIndex);
    });
  }

  const contactButton = document.getElementById('object-slider-contact');
  const orderFormElement = document.getElementById('order-form');

  if (contactButton && orderFormElement) {
    contactButton.addEventListener('click', () => {
      orderFormElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });
  }
};

export default initSlider;
